import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

export async function createReferralCampaign(payload) {
  const fd = new FormData();

  Object.keys(payload).forEach(key => {
    fd.append(key, payload[key]);
  });

  fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/create`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } }
  );

  return res.data;
}

export async function getReferralCampaigns(user_id,page,search_key) {

  const fd = new FormData();
  fd.append("user_id", user_id+"");
  fd.append("page", page+"");
  fd.append("search_key", search_key+"");

  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/getList`,
    fd
  );

  return res.data;
}

export async function sendReferral(
  referral_leads_camp,
  referral_leads_name,
  referral_leads_fname,
  referral_leads_phone,
  referral_leads_email,
  referral_leads_note
) {

  const fd = new FormData();

  fd.append("referral_leads_camp", referral_leads_camp+"");

  fd.append("referral_leads_name", referral_leads_name+"");
  fd.append("referral_leads_fname", referral_leads_fname+"");

  fd.append("referral_leads_phone", referral_leads_phone+"");
  fd.append("referral_leads_email", referral_leads_email+"");

  fd.append("referral_leads_note", referral_leads_note+"");


  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/sendReferral`,
    fd,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );

  return res.data;
}

export async function getReferralLeads(camp_id,page,search_key) {

  const fd = new FormData();
  fd.append("camp_id", camp_id);
  fd.append("page", page);
  fd.append("search_key", search_key);

  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/getLeads`,
    fd
  );

  return res.data;
}

export async function submitReferralLead(payload) {

  const fd = new FormData();

  Object.keys(payload).forEach(key => {
    fd.append(key, payload[key]);
  });

  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/submitLead`,
    fd
  );

  return res.data;
}

export async function getRefById(ref_camp_id) {

  const fd = new FormData();
  fd.append("ref_camp_id", ref_camp_id);
  // alert(ref_camp_id+"");
  const res = await axios.post(
    `${apiBaseUrl}referralcampaign/get_ref_by_id`,
    fd
  );

  return res.data;
}